var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "login" } }, [
    _c("section", { staticClass: "section" }, [
      _c("div", { staticClass: "container has-text-centered" }, [
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            {
              staticClass:
                "column is-6 is-offset-3 is-4-desktop is-offset-4-desktop",
            },
            [
              !_vm.showRecover
                ? _c("div", [
                    _vm.showNormalLogin
                      ? _c("div", { staticClass: "box" }, [
                          _c("img", {
                            staticClass: "image",
                            attrs: { src: "/statics/signar-logo.svg", alt: "" },
                          }),
                          _vm._v(" "),
                          _vm.error
                            ? _c(
                                "div",
                                { staticClass: "message is-danger is-size-7" },
                                [
                                  _c("div", { staticClass: "message-body" }, [
                                    _vm._v(_vm._s(_vm.error)),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "content" }, [
                            _c("p", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.username,
                                    expression: "username",
                                  },
                                ],
                                ref: "inputEmail",
                                staticClass: "input is-medium",
                                attrs: {
                                  type: "email",
                                  placeholder: "Usuario",
                                },
                                domProps: { value: _vm.username },
                                on: {
                                  focus: function ($event) {
                                    return _vm.reset()
                                  },
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return _vm.submit.apply(null, arguments)
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.username = $event.target.value
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.password,
                                    expression: "password",
                                  },
                                ],
                                staticClass: "input is-medium",
                                attrs: {
                                  type: "password",
                                  placeholder: "Contraseña",
                                },
                                domProps: { value: _vm.password },
                                on: {
                                  focus: function ($event) {
                                    return _vm.reset()
                                  },
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return _vm.submit.apply(null, arguments)
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.password = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "buttons is-centered" }, [
                            _c(
                              "button",
                              {
                                staticClass: "button is-primary is-fullwidth",
                                on: {
                                  click: function ($event) {
                                    return _vm.submit()
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "fas fa-sign-in-al" }),
                                _vm._v("  Iniciar sesión\n                "),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "button is-primary is-outlined is-fullwidth",
                                on: {
                                  click: function ($event) {
                                    return _vm.externalLogin()
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "far fa-id-badge" }),
                                _vm._v(
                                  "  Ingresar con ID externo\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "button is-white is-fullwidth",
                                on: {
                                  click: function ($event) {
                                    _vm.reset(true)
                                    _vm.showRecover = !_vm.showRecover
                                  },
                                },
                              },
                              [_vm._v("¡Olvide mi contraseña!")]
                            ),
                          ]),
                        ])
                      : _c("div", { staticClass: "box" }, [
                          !_vm.loadingProviders
                            ? _c("div", { staticClass: "content" }, [
                                _vm._m(0),
                                _vm._v(" "),
                                _c("p", { staticClass: "is-size-7" }, [
                                  _vm._v("Iniciar sesión con..."),
                                ]),
                                _vm._v(" "),
                                !_vm.providersToShow.length
                                  ? _c("p", { staticClass: "is-size-7" }, [
                                      _vm._v(
                                        "No existen proveedores de identidad externos"
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "buttons" },
                                  _vm._l(
                                    _vm.providersToShow,
                                    function (provider, index) {
                                      return _c(
                                        "button",
                                        {
                                          key: index,
                                          staticClass:
                                            "button is-fullwidth is-primary is-outlined",
                                          on: {
                                            click: function ($event) {
                                              return _vm.doExternalLogin(
                                                provider
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(provider.nombre) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "buttons" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-white is-fullwidth",
                                      on: {
                                        click: function ($event) {
                                          _vm.showNormalLogin =
                                            !_vm.showNormalLogin
                                        },
                                      },
                                    },
                                    [_vm._v("Volver")]
                                  ),
                                ]),
                              ])
                            : _c("div", { staticClass: "div" }, [
                                _c("i", { staticClass: "fas fa-sync fa-spin" }),
                              ]),
                        ]),
                  ])
                : _c("div", { staticClass: "box" }, [
                    _c("p", { staticClass: "is-500" }, [
                      _vm._v("¿Olvido su contraseña?"),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _vm._v(
                        "Ingrese su email para recibir un correo con los pasos a seguir para recuperar su contraseña"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.error
                      ? _c(
                          "div",
                          { staticClass: "notification is-danger is-size-7" },
                          [
                            _c("div", { staticClass: "message-body" }, [
                              _vm._v(_vm._s(_vm.error)),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showRecoverSuccess
                      ? _c(
                          "div",
                          { staticClass: "message is-success is-size-7" },
                          [
                            _c("div", { staticClass: "message-body" }, [
                              _vm._v(
                                "Hemos enviado a tu casilla de email un correo electrónico para poder recuperar tu cuenta."
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _c("p", { staticClass: "control" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.username,
                              expression: "username",
                            },
                          ],
                          ref: "inputEmail",
                          staticClass: "input is-medium",
                          attrs: { type: "email", placeholder: "Email" },
                          domProps: { value: _vm.username },
                          on: {
                            focus: function ($event) {
                              return _vm.reset()
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.recover.apply(null, arguments)
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.username = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "div",
                        { staticClass: "control" },
                        [
                          _c("vue-recaptcha", {
                            attrs: { sitekey: _vm.siteKey },
                            on: {
                              verify: _vm.catchRecaptcha,
                              expired: function ($event) {
                                _vm.recaptcha = null
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "buttons is-centered" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-primary is-fullwidth",
                          attrs: { disabled: !_vm.recaptcha },
                          on: {
                            click: function ($event) {
                              return _vm.recover()
                            },
                          },
                        },
                        [_vm._v("Enviar email de recuperación")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button is-white is-fullwidth",
                          on: {
                            click: function ($event) {
                              _vm.reset(true)
                              _vm.showRecover = !_vm.showRecover
                            },
                          },
                        },
                        [_vm._v("Volver")]
                      ),
                      _vm._v(" "),
                      _c("br"),
                    ]),
                  ]),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("p", { staticClass: "is-size-7 has-text-grey" }, [
                _vm._v("Ver. " + _vm._s(_vm.version)),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "is-500" }, [
      _c("i", { staticClass: "far fa-id-badge" }),
      _vm._v("  Ingresar con ID externo"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { attrs: { href: "https://lyris.com.ar", target: "_blank" } },
      [
        _c("img", {
          staticClass: "lyris-logo mt-5",
          attrs: { src: "/statics/lyris-grey.svg", alt: "Lyris IT" },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "is-size-7 my-3" }, [
      _c(
        "a",
        {
          staticClass: "mx-2 has-text-grey",
          attrs: {
            target: "_blank",
            href: "https://soporte-lyris.atlassian.net/servicedesk/customer/portals",
          },
        },
        [
          _vm._v("Soporte "),
          _c("i", { staticClass: "fas fa-external-link-alt fa-fw" }),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "mx-2 has-text-grey",
          attrs: { target: "_blank", href: "https://docs.signar.com.ar" },
        },
        [
          _vm._v("Documentación "),
          _c("i", { staticClass: "fas fa-external-link-alt fa-fw" }),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "mx-2 has-text-grey",
          attrs: {
            target: "_blank",
            href: "https://docs.signar.com.ar/release-notes/",
          },
        },
        [
          _vm._v("Changelog "),
          _c("i", { staticClass: "fas fa-external-link-alt fa-fw" }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }